/**
 * Photo reviews carousel. Uses fixed step = card width + gap (equal flex basis).
 * Resize: only re-layout when the viewport *width* changes (not when a scaled
 * card resizes, which was cancelling animation via ResizeObserver).
 */
(function () {
  var reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setWidths(view, list, wPx) {
    for (var i = 0; i < list.length; i++) {
      list[i].style.flex = '0 0 ' + wPx + 'px';
      list[i].style.maxWidth = wPx + 'px';
    }
  }

  function initOne(section) {
    var view = section.querySelector('.cosmic-reviews-cards__viewport');
    var track = section.querySelector('[data-cosmic-reviews-track]');
    if (!view || !track) return;
    if (section.getAttribute('data-carousel-initialized') === '1') return;
    if (reduceMq.matches) {
      track.classList.add('is-static');
      return;
    }
    var originals = [].slice.call(
      track.querySelectorAll('.cosmic-reviews-cards__card[data-review-idx]')
    );
    if (originals.length < 1) return;
    if (originals.length < 3) {
      track.classList.add('is-static');
      if (originals.length === 2) {
        originals[1].classList.add('cosmic-reviews-cards__card--center');
      }
      return;
    }
    section.setAttribute('data-carousel-initialized', '1');

    var autoplayMs = parseInt(section.getAttribute('data-autoplay-ms'), 10);
    if (!autoplayMs || autoplayMs < 1000) autoplayMs = 5000;
    var TR = section.getAttribute('data-track-transition');
    if (!TR) TR = 'transform 0.55s cubic-bezier(0.4, 0, 0.2, 1)';

    var n = originals.length;
    for (var c = 0; c < n; c++) {
      var cl = originals[c].cloneNode(true);
      cl.setAttribute('data-review-clone', '1');
      cl.removeAttribute('data-review-idx');
      track.appendChild(cl);
    }

    var all = [].slice.call(track.querySelectorAll('.cosmic-reviews-cards__card'));
    var leftIdx = 0;
    var stepPx = 0;
    var timer;
    var busy = false;
    var loopTid;
    var lastViewW = -1;

    function measure() {
      var csView = window.getComputedStyle(view);
      var padX =
        (parseFloat(csView.paddingLeft) || 0) +
        (parseFloat(csView.paddingRight) || 0);
      var innerW = Math.max(0, Math.floor(view.clientWidth - padX));
      var vw = view.offsetWidth;
      if (window.innerWidth < 768) {
        /* One slide = full viewport content width; theme gap sits between slides (off-screen) */
        setWidths(view, all, Math.max(220, innerW));
      } else {
        var gap = 20;
        var cs = window.getComputedStyle(track);
        if (cs.gap && cs.gap !== 'normal') {
          var g = parseFloat(cs.gap);
          if (!isNaN(g)) gap = g;
        }
        var w3 = (vw - 2 * gap) / 3;
        setWidths(view, all, w3);
      }
      void track.offsetWidth;
      if (all.length > 1) {
        var a0 = all[0].getBoundingClientRect();
        var a1 = all[1].getBoundingClientRect();
        stepPx = Math.round(a1.left - a0.left);
        if (stepPx < 1) {
          var gap2 = 20;
          var cs2 = window.getComputedStyle(track);
          if (cs2.gap && cs2.gap !== 'normal') {
            var g2 = parseFloat(cs2.gap);
            if (!isNaN(g2)) gap2 = g2;
          }
          stepPx = Math.round(all[0].getBoundingClientRect().width + gap2);
        }
      } else {
        stepPx = 0;
      }
    }

    function scrollPx(i) {
      if (i <= 0) return 0;
      return i * stepPx;
    }

    function clearCenter() {
      for (var j = 0; j < all.length; j++) {
        all[j].classList.remove('cosmic-reviews-cards__card--center');
      }
    }

    function applyCenter() {
      clearCenter();
      var c;
      if (window.innerWidth < 768) {
        c = leftIdx;
      } else {
        c = leftIdx + 1;
      }
      if (c < all.length && all[c]) {
        all[c].classList.add('cosmic-reviews-cards__card--center');
      }
    }

    function setTransform(px, withTransition) {
      if (withTransition) {
        track.style.transition = TR;
      } else {
        track.style.transition = 'none';
      }
      track.style.transform = 'translate3d(' + -Math.round(px) + 'px,0,0)';
    }

    function clearLoopTimer() {
      if (loopTid) {
        clearTimeout(loopTid);
        loopTid = null;
      }
    }

    function syncAfterLoop() {
      clearLoopTimer();
      busy = true;
      track.removeEventListener('transitionend', onEnd);
      setTransform(0, false);
      void track.offsetWidth;
      leftIdx = 0;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          track.style.transition = TR;
          applyCenter();
          busy = false;
        });
      });
    }

    function onEnd(e) {
      clearLoopTimer();
      if (e) {
        if (e.target !== track) return;
        if (e.propertyName && e.propertyName.indexOf('transform') === -1) return;
      }
      if (leftIdx === n) {
        syncAfterLoop();
        return;
      }
      busy = false;
    }

    function scheduleLoopFallback() {
      clearLoopTimer();
      loopTid = window.setTimeout(function () {
        loopTid = null;
        if (leftIdx === n && busy) {
          onEnd();
        } else {
          busy = false;
        }
      }, 700);
    }

    function goNext() {
      if (busy) return;
      if (stepPx < 1) {
        return;
      }
      if (leftIdx === n) {
        syncAfterLoop();
        return;
      }
      if (leftIdx < n - 1) {
        leftIdx += 1;
        setTransform(scrollPx(leftIdx), true);
        applyCenter();
        return;
      }
      if (leftIdx === n - 1) {
        leftIdx = n;
        busy = true;
        track.addEventListener('transitionend', onEnd, false);
        scheduleLoopFallback();
        setTransform(scrollPx(n), true);
        applyCenter();
        return;
      }
    }

    function tick() {
      if (document.hidden) return;
      goNext();
    }

    function onViewportResize() {
      var w = view.offsetWidth;
      if (w === lastViewW) {
        return;
      }
      lastViewW = w;
      var prevLeft = leftIdx;
      measure();
      if (stepPx < 1) {
        return;
      }
      setTransform(scrollPx(prevLeft), false);
      void track.offsetWidth;
      applyCenter();
    }

    var resizeDebounce;
    function onWindowResize() {
      clearTimeout(resizeDebounce);
      resizeDebounce = setTimeout(function () {
        onViewportResize();
      }, 120);
    }

    function layoutAndGoHome() {
      measure();
      lastViewW = view.offsetWidth;
      leftIdx = 0;
      setTransform(0, false);
      void track.offsetWidth;
      applyCenter();
    }

    layoutAndGoHome();
    timer = window.setInterval(tick, autoplayMs);
    window.addEventListener('resize', onWindowResize, false);

    function vis() {
      if (document.hidden) {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      } else if (!timer) {
        timer = window.setInterval(tick, autoplayMs);
      }
    }
    document.addEventListener('visibilitychange', vis, false);
  }

  function boot() {
    document
      .querySelectorAll('.cosmic-reviews-cards[data-cosmic-reviews-carousel]')
      .forEach(function (s) {
        initOne(s);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
